import { addDays, startOfDay } from "date-fns";

/**
 * Base date the snooze offsets are counted from: the reminder date while it is
 * still in the future, otherwise today. Quick options ("tomorrow", "in 3 days")
 * add their offset to this base, so a reminder due on 22.9. snoozed with
 * "tomorrow" lands on 23.9. — never before the reminder itself.
 */
export const getSnoozeBaseDate = (
	reminderDate: Date,
	today: Date = new Date(),
): Date => {
	const todayStart = startOfDay(today);
	const reminderStart = startOfDay(reminderDate);

	return reminderStart.getTime() > todayStart.getTime()
		? reminderStart
		: todayStart;
};

export const getSnoozeOptionDate = (baseDate: Date, days: number): Date =>
	startOfDay(addDays(baseDate, days));

/** The API requires `snoozedUntil` to be strictly after the reminder date. */
export const isSnoozeDateAfterReminder = (
	snoozedUntil: Date,
	reminderDate: Date,
): boolean =>
	startOfDay(snoozedUntil).getTime() > startOfDay(reminderDate).getTime();
